import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';

@EnableClassTelemetry()
@Injectable()
export class WidgetLimiterService {
  private max_concurrent = 2;
  private open = 0;

  constructor() {
    const appConfig = (window as any).appConfig;
    if (appConfig && appConfig.limits && appConfig.limits.widgetMaxConcurrent) {
      this.max_concurrent = appConfig.limits.widgetMaxConcurrent;
    }
  }

  async execute(f: (...args) => Promise<void>, ...args: any[]): Promise<any> {
    const x = async () => {
      while (this.open >= this.max_concurrent) {
        await this.delay(500);
      }
      this.open++;
      const r = await f(...args);
      this.open--;
      return r;
    };
    return x();
  }

  set_max_concurrent(max_concurrent: number) {
    this.max_concurrent = max_concurrent;
  }

  get_max_concurrent(): number {
    return this.max_concurrent;
  }

  private async delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
